export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/claim.worker.4eb0cf8d.worker.js");
}
